import { type LoaderArgs, json } from '@remix-run/node'
import { useLoaderData } from '@remix-run/react'
import ImageOverlay from '~/components/image-overlay.tsx'
import {
	Accordion,
	AccordionContent,
	AccordionItem,
	AccordionTrigger,
} from '~/components/ui/accordion.tsx'

const faqs = [
	{
		title: 'Is this a school?',
		answer:
			'In so far as learning and growth occur, yes, Via is a school.  However, the academic formation is only one of several parts of the overall experience, so we think of it as a formation program or a bridge year.',
	},
	{
		title: 'What are the ages of Via Fellows?',
		answer:
			'Some of Via’s current Fellows are recent high school graduates, but some of them have already been in college.  Via is for college-aged adults.',
	},
	{
		title: 'Is Via Catholic?',
		answer:
			'We believe that the Catholic Church is the Church founded by Christ Jesus and it is through the Catholic Church that Christ Jesus normally feeds His flock.  All of Via’s participants and staff members are practicing Roman Catholics.',
	},
	{
		title: 'Is it co-ed?',
		answer:
			'Yes, Via has both a men’s and a women’s house and both cohorts share much of their life together.',
	},
	{
		title: 'What does a typical week look like at Via?',
		answer: 'Below is an example of a typical week at Via.',
	},
	{
		title: 'What do Via Fellows study?',
		answer:
			'Via’s seminars focus on the foundations of Western civilization, featuring the literature and philosophy of ancient Babylon, Israel, Greece, Rome, and Christianity.',
	},
	{
		title: 'How much does it cost?',
		answer:
			'All of Via’s costs are covered by the generous donations of members of the wider Church.  Because Fellows’ formation is ultimately aimed at entering a life of service for the wider Church community, we believe their formation should be provided for by the wider Church community.',
	},
]

export async function loader({ request }: LoaderArgs) {
	return json({ faqs })
}

export default function FAQRoute() {
	const { faqs } = useLoaderData<typeof loader>()

	return (
		<section id="faq" className="relative min-h-[1250px] bg-section">
			<ImageOverlay src="/img/via4.png" position="46% 78%" opacity="0.0" />
			<div className="relative z-20 mx-auto flex w-[800px] flex-col space-y-10 p-6 md:p-12">
				<h2 className="font-title text-5xl">FAQ</h2>
				<Accordion type="single" collapsible className="w-full">
					{faqs.map(({ answer, title }) => (
						<AccordionItem key={title} value={title}>
							<AccordionTrigger className="pb-8 font-title text-3xl">
								{title}
							</AccordionTrigger>
							<AccordionContent className="text-2xl leading-8">
								{answer}
							</AccordionContent>
						</AccordionItem>
					))}
				</Accordion>
			</div>
		</section>
	)
}
